import { api } from '@/api/client';

/**
 * Pre-launch interest — BUILD-PLAN §24, §29.
 *
 * The response is deliberately identical whether or not the address was
 * already on the list, so this cannot be used to test whether a given person
 * is interested in the shop. Nothing here should ever branch on "already
 * subscribed", because the server does not say.
 */
export function subscribeToLaunch(email: string): Promise<null> {
  return api.post<null>('/launch/subscribe', { email });
}
